import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../common/PageLayout';
import '../css/Step1.css';
import { handleFileDownload } from '../utils/fileHandlers/downloadHandler';
import { exportKoreanProductExcel, exportKoreanCategoryExcel, exportKoreanDisplayExcel, exportKrCategoryOrderCsv } from '../utils/api/productApi';

const ExportKoreanDataExcel = () => {
    const [error, setError] = useState(null);
    const [statusMessage, setStatusMessage] = useState('대기중...');
    const [isImporting, setIsImporting] = useState(false);
    const [isFinished, setIsFinished] = useState(false);
    const [animatedText, setAnimatedText] = useState('Download Korean Data Excel');

    useEffect(() => {
        // 기존 텍스트 애니메이션 로직 유지
        if (isImporting) {
            let currentIndex = 0;
            const fullText = 'Downloading Korean Data Excel';
            const timer = setInterval(() => {
                setAnimatedText(fullText.slice(0, currentIndex + 1));
                currentIndex++;
                if (currentIndex === fullText.length) currentIndex = 0;
            }, 150);
            return () => clearInterval(timer);
        }
    }, [isImporting]);
    // 개별 다운로드 처리 함수
    const handleDownloadProcess = async (apiFunction, description) => {
        try {
            setStatusMessage(`Downloading ${description}...`);
            const apiResponse = await apiFunction();

            if (!apiResponse.success) {
                throw apiResponse.error;
            }

            const downloadResult = await handleFileDownload(apiResponse);
            setStatusMessage(downloadResult.message);

            return downloadResult.success;
        } catch (error) {
            console.error(`Error downloading ${description}:`, error);
            throw error; // 상위 함수에서 처리하도록 에러를 전파
        }
    };

    // 메인 제출 함수
    const handleSubmit = async (formData) => {
        setError("");
        setIsImporting(true);
        setStatusMessage('')
        try {
            // 순차적으로 다운로드 처리
            const downloads = [
                // { fn: () => exportKoreanProductExcel(formData), description: 'Product Excel' },
                // { fn: () => exportKoreanCategoryExcel(formData), description: 'Category Excel' },
                // { fn: () => exportKoreanDisplayExcel(formData), description: 'Display Excel' },
                { fn: () => exportKrCategoryOrderCsv(formData), description: 'Category Order CSV' },
            ];

            for (const download of downloads) {
                const success = await handleDownloadProcess(download.fn, download.description);

                if (!success) {
                    setStatusMessage(`Failed to download ${download.description}`);
                    return;
                }
            }

            setStatusMessage("All files downloaded successfully.");
            setIsFinished(true);
        } catch (error) {
            console.error('Error:', error);
            setError('Error occurred during download process.');
            setStatusMessage('Download failed.');
        } finally {
            setIsImporting(false);
        }
    };

    const validateFile = (file) => {
        const validTypes = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel"
        ];
        return validTypes.includes(file.type);
    };

    return (
        <PageLayout
            title="Korea Product Data API"
            submitButtonText="Download Korean Data Excel"
            description={
                <p className={`animated-text ${isImporting ? 'importing' : ''}`}>
                    {animatedText}
                </p>
            }
            onSubmit={handleSubmit}
            isFileUpload={false}
            validateFile={validateFile}
            error={error}
            statusMessage={statusMessage}
            multiple={true}
            acceptTypes=".xlsx,.xls"
        >
            {isFinished && !isImporting && (
                <Link to="/bulk-db-conversion" className="next-button">
                    Next
                </Link>
            )}
        </PageLayout>
    );
};

export default ExportKoreanDataExcel;